import styled from 'styled-components'
import Breakpoint from '../../utils/breakpoint'
import OurStory_500years from '../../assets/images/OurStory_500years.jpg'
// import OurStory_500yearsLow from '../../assets/images/OurStory_500years_Low.jpg'
import OurStory_500years_Sm from '../../assets/images/mobile-ourstory-civilization.jpg'

const {mobile, desk, xs, sm, md, lg, xl, xxl} = Breakpoint
export const Box = styled.div`
  width: 100%;
  // @media (max-width: ${mobile}px) {
  //   width: 260px;
  // }
  & img {
    width: 100%;
    height: auto;
    display: block;
    filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.4));
  }
`
export const BoxWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const Container = styled.div`
  background-image: url('${OurStory_500years}');
  background-color: #394b91;
  //min-height: calc(100vh - 158px);
  min-height: 75vw;
  background-position: 0 0;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;

  @media (max-width: 767px) {
    background-image: url('${OurStory_500years_Sm}') !important;
    background-size: 100% auto;
    background-position: 50% 0;
    min-height: 150vw;
  }
  @media (768px <= width<= 1045px) {
    background-position: 30% 0;
  }
  @media (1046px <= width<= 1300px) {
    background-position: 26% 0;
  }
`
//
// export const LoadingBox = styled.div`
//   padding-top: 25px;
//   padding-bottom: 25px;
// `
//
// export const WidthBox = styled(Box)`
//   width: ${({ratio}) => `${ratio * 100}%`};
// `
